import React, { useEffect, useState } from "react";
import Patron_navbar from "../Patron_Navbar";
import { makeAuthenticatedGETRequest } from "../../services/serverHelper";
import { patronProfilePoints } from "../../services/apis";
import { useSelector, useDispatch } from "react-redux";
import { setAccessToken, setRefreshToken } from "../../reducer/slices/authSlice"; // adjust path if needed
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Axios from 'axios';
import Skill_Card from "../../ArtisitPages/Dashboard/Skill_Card";
// import dance from "./assets/dance.png";
// import news/Img from "./assets/news.png";

import {
  FaUser,
  FaBriefcase,
  FaBook,
  FaNewspaper,
  FaSignOutAlt,
  FaIdBadge,
  FaEnvelope,
} from "react-icons/fa";
// import "./dashboard.css";
import Sidebar from "../PatronSidebar";
import Newsletter  from "../../news/Newsletter";

// const API_KEY = "a508cd51cc1c4e68b737330667020e05";
// const API_URL = `https://newsapi.org/v2/top-headlines?country=in&category=entertainment&apiKey=${API_KEY}`;
const API_KEY = process.env.REACT_APP_GNEWS_API_KEY; // GNews API key

const CATEGORY_KEYWORDS = {
  Cultural: '"culture India" OR "cultural festival India" OR dance OR music OR art OR "indian instruments" OR "indian dance"',
  Dance: 'dance performance India OR Bharatanatyam OR Kathak',
  Music: 'live music India OR concert OR musician India',
  Theatre: 'theatre OR drama OR stage play India',
  // Art: 'art exhibition India OR painting showcase',
};

const PatronDashBoard = () => {
  const { accessToken } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [appliedData, setAppliedData] = useState([]);
  const [data, setData] = useState([]);
//   const [latestNews, setLatestNews] = useState([]);
  const [revenue, setRevenue] = useState(0);
  const [applied, setApplied] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const id = localStorage.getItem('artId');
  const [activeCategory, setActiveCategory] = useState('Dance');
  const [newsItems, setNewsItems] = useState([]);
  
    const fetchNews = async () => {
        const query = CATEGORY_KEYWORDS[activeCategory];
        const cachedData = localStorage.getItem(`news_${activeCategory}`);
        const cachedTime = localStorage.getItem(`news_${activeCategory}_time`);

        if (cachedData && cachedTime && (Date.now() - cachedTime < 15 * 60 * 1000)) {
        setNewsItems(JSON.parse(cachedData));
        return;
        }
        const url = `https://gnews.io/api/v4/search?q=${encodeURIComponent(query)}&lang=en&country=in&max=10&sortby=date&apikey=${API_KEY}`;

        try {
        // const res = await fetch(url);
        const res = await Axios.get(url);
        const data = res.data;
        console.log('Fetched news data:', data);
        // 2. Save to LocalStorage
        localStorage.setItem(`news_${activeCategory}`, JSON.stringify(data?.articles));
        localStorage.setItem(`news_${activeCategory}_time`, Date.now().toString());
        setNewsItems(data?.articles || []);
        } catch (error) {
        console.error('Error fetching news:', error);
        if (cachedData) {
            setNewsItems(JSON.parse(cachedData));
        } else {
            setNewsItems([]);
        }
        setNewsItems([]);
        }
    };
  

  // Fetch Applications

  
//   const fetchApplication = async () => {
//     try {
//       const response = await makeAuthenticatedGETRequest(
//         statusOfAppliPoints.FETCH_APPLIED_APPLI_API,
//         accessToken
//       );
//       if (response.status === "success") setAppliedData(response.data);
//       else toast.error("Cannot fetch applications, please refresh.");
//     } catch (error) {
//       console.error(error);
//     }
//   };

  // Fetch Opportunities
  const fetchPatronData = async () => {
    try {
      const response = await makeAuthenticatedGETRequest(
        `${patronProfilePoints.FETCH_PATRON_PROFILE_API}/${id}`,
        accessToken
      );
      console.log(response);
      if (response?.status === "success") setData(response.data);
    } catch (error) {
        console.log(error);
        toast.error("Server error, please try again.");
    }
  };

  // Fetch News
//   const fetchNews = async () => {
//     try {
//       const res = await fetch(API_URL);
//       const data = await res.json();
//       setLatestNews(data.articles || []);
//     } catch (err) {
//       console.error("Error fetching news:", err);
//     }

//   };

  // Fetch Hired Applications
//   const hire = async () => {
//     try {
//       const response = await makeAuthenticatedGETRequest(
//         statusOfAppliPoints.FETCH_APPLIED_APPLI_API,
//         accessToken
//       );
//       const filteredData = response.data.filter((item) => item.status === "Hired");
//       setApplied(filteredData.length);
//       setRevenue(
//         filteredData.reduce((sum, e) => sum + (e.opportunity?.budget || 0), 0)
//       );
//     } catch (error) {
//       console.log(error);
//     }
//   };

  useEffect(() => {
    // fetchApplication();
    // hire();
    fetchPatronData();
    // fetchNews();
  }, []);

  useEffect(() => {
    fetchNews();
  }, [activeCategory]);

//   const slicedJobData = jobData.slice(0, 3);
  const slicedNews = newsItems.slice(0, 3);

  return (
    <>
      <Patron_navbar />
      <div className="dashboard-layout">
        <Sidebar />
        {/* -------- Main Dashboard Content -------- */}
        <main className="dashboard-content">
          {/* ---------- HEADER ---------- */}
          <div className="dashboard-header">
            <h1 className="dashboard-title">Dashboard</h1>
            <p  style={{fontWeight:"semi-bold", fontSize:"20px", color:"#464545"}}>
              Welcome back! Here’s your quick performance overview 🚀
            </p>
          </div>

          {/* ---------- STAT BOXES ---------- */}
          <div className="stats-grid">
            {[
              { title: "Opportunities", value: data?.personalInfo?.opportunityIds?.length },
              { title: "Applications", value: data?.personalInfo?.applicationIds?.length },
              { title: "Performance", value: data?.personalInfo?.performanceIds?.length },
            //   { title: "Revenue (INR)", value: revenue },
            ].map((stat, i) => (
              <div key={i} className="stat-card">
                <p className="stat-title">{stat.title}</p>
                <p className="stat-value">{stat.value}</p>
              </div>
            ))}
          </div>

          {/* ---------- OPPORTUNITIES ---------- */}
          <section className="section">
            <div className="section-header">
              <h2>My Opportunities</h2>
              <Link to="/Artist_Opportunities" className="artist-red-btn">
                View More
              </Link>
            </div>
            <div className="card-grid" >
              {data?.personalInfo?.opportunityIds?.map((job, idx) => (
                <div key={idx} className="opp-card">
                  {/* <img src={dance} alt="opportunity" className="card-img" style={{height:"370px"}} /> */}
                  <div className="card-body">
                    <h3>{job.purpose}</h3>
                    <p>Budget: ₹{job.budget}</p>
                    <p>
                      Event Date:{" "}
                      {new Date(job.performanceDate).toLocaleDateString("en-US", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })}
                    </p>
                    <Link to="/Artist_Opportunities" className="card-link">
                      Explore →
                    </Link>
                  </div>
                </div>
              ))} 
            </div>
          </section>

          {/* ---------- SKILLS ---------- */}
          <section className="section">
            <div className="section-header">
              <h2>Skill Development</h2>
              <Link to="/CourseCategories" className="artist-red-btn">
                View More
              </Link>
            </div>
            <Skill_Card />
          </section>

          {/* ---------- NEWS ---------- */}
          <section className="section">
            <div className="section-header">
              <h2>Latest News</h2>
              <Link to="/news" className="artist-red-btn">
                View More
              </Link>
            </div>
            <div className="card-grid">
                {slicedNews.map((article, idx) => (
                 <div key={idx} className="card"> 
                  <img
                    src={article.image || 'https://via.placeholder.com/250x140.png?text=No+Image'}
                    alt="news"
                    className="card-img"
                  />
                  <div className="card-body">
                    <h3>{article.title.slice(0, 40)}...</h3>
                    <p className="small">By {article.author || "Unknown"}</p>
                    <p>{article.description?.slice(0, 60)}...</p>
                    <p className="small">
                      Published:{" "}
                      {new Date(article.publishedAt).toLocaleDateString("en-US", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })}
                    </p>
                    <Link to={article.url} className="card-link">
                      Read More →
                    </Link>
                  </div>
                </div>
              ))}

            </div>
          </section>
        </main>
      </div>
    </>
  );
};

export default PatronDashBoard;